<template>
  <div>
    <h1 v-if="$store.state.auth && $store.state.auth.user && $store.state.root">
      Page Not Found!
    </h1>
    <h1 v-else></h1>
  </div>
</template>

<script>
export default {
  name: "NotFound"
}
</script>